import { render, staticRenderFns } from "./BookingAddSavedPerson.vue?vue&type=template&id=4614cc73&"
import script from "./BookingAddSavedPerson.vue?vue&type=script&lang=ts&"
export * from "./BookingAddSavedPerson.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports